/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeContractImportErrors } from './employeeContractImportErrors';


export interface EmployeeContractImportApiModel { 
    employeePersonalNumber?: string | null;
    employeeFirstName?: string | null;
    employeeLastName?: string | null;
    organizationName?: string | null;
    occupationName?: string | null;
    workplaceName?: string | null;
    validityStart?: string | null;
    validityEnd?: string | null;
    errorMessages?: Array<EmployeeContractImportErrors> | null;
}

